module.exports = __webpack_public_path__ + "img/chat.41dbdd01.svg";